import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(({ palette, shape }: Theme) => ({
  root: {
    fontFamily: 'Lato',
    backgroundColor: palette.common.white,
    overflowX: 'hidden',
    width: '100%',
    boxShadow: '0 5px 20px 0 rgba(32, 49, 91, 0.2)',
    borderRadius: shape.borderRadius,
    '& > div[style*="width: 6px;"]': {
      zIndex: 3,
      '& > div': {
        backgroundColor: '#CCCCCC !important',
      },
    },
  },
}));
